import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '',
  timeout: 20000
})
service.interceptors.request.use(
  config => {
     config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
//    header:{
//          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
//      },
    // config.headers['Accept'] = "application/json"
    //config.headers['token'] = "94fb1501130b4c6abd2ab3b4b0e31c7a"
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response
    return res
  },
  error => {
    console.log('err' + error)
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
export default service
